document.addEventListener('DOMContentLoaded', () => {
  const basePicker = document.getElementById('variant_picker-1');
  if (!basePicker) return;

  const productId = document.querySelector('product-info')?.dataset.productId;
  if (productId === '9456931143945') return;

  const otherPickers = [];
  for (let i = 2; ; i++) {
    const picker = document.getElementById(`variant_picker-${i}`);
    if (!picker) break;
    picker.style.display = 'none';
    otherPickers.push(picker);
  }

  const baseRadios = basePicker.querySelectorAll('.js.product-form__input input[type="radio"]');
  if (baseRadios.length === 0) return;

   const formatMoney = (cents) => {
    return (parseInt(cents, 10) / 100).toFixed(2).replace('.', ',') + '€';
  };

  baseRadios.forEach(radio => {
    const label = basePicker.querySelector(`label[for="${radio.id}"]`);
    const container = radio.closest('.js.product-form__input');
    if (!label || !container) return;

    const optionValue = (label.dataset.optionValue || '').trim().toLowerCase();
    if (optionValue.includes('/')) {
      const [left, right] = optionValue.split('/').map(s => s.trim());
      if (left.toLowerCase() !== right.toLowerCase()) {
        container.style.display = 'none';
        return;
      }
      radio.dataset.quantity = left;
    } else {
      radio.dataset.quantity = optionValue;
    }

    const variantIndex = parseInt(radio.id.split('-').pop(), 10) + 1;
    const dataInput = document.querySelector(`.product-variants-database input[id="${variantIndex}"]`);
    if (dataInput) {
      const price = parseInt(dataInput.dataset.price || '', 10);
      const compareAt = parseInt(dataInput.dataset.compareAtPrice || '', 10);
      const regularPriceEl = label.querySelector('.regular-price');
      const discountEl = label.querySelector('.price-discount');

      const hasCompare = !isNaN(compareAt) && compareAt > price;

      if (regularPriceEl && !isNaN(price)) {
        regularPriceEl.textContent = formatMoney(price);
      }

      if (discountEl) {
        discountEl.textContent = hasCompare
         ? `Économisez ${Math.round(((compareAt - price) / compareAt) * 100)}%`
         : '';
      }
    }
  });
  if (typeof updateMainButtonPrice === 'function') {
    updateMainButtonPrice();
  }
  baseRadios.forEach(radio => {
    radio.addEventListener('change', () => {
      const quantity = radio.dataset.quantity;
      otherPickers.forEach(picker => {
        const target = Array.from(
          picker.querySelectorAll('.js.product-form__input input[type="radio"]')
        ).find(r => {
          const l = picker.querySelector(`label[for="${r.id}"]`);
          return l && (l.dataset.optionValue || '').trim().toLowerCase() === quantity;
        });
        if (target) {
          target.checked = true;
          target.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  });
});
